import {
    CHANGE_PASS_REQUESTING,
  } from './constants'
  
// In order to perform an action of type CHANGE_PASS_REQUESTING
// we need an email and password
export const changePassRequest = function changePassRequest (formData) {
  return {
    type: CHANGE_PASS_REQUESTING,
    payload: formData, 
  }
}
  
export default changePassRequest


// WEBPACK FOOTER //
// ./src/views/Pages/ChangePassword/actions.js